import { WhatsappConstants } from '../../channels/whatsapp/WhatsappConstants';
import { GroupsUriTemplates } from './GroupsUriTemplates';
import { GroupsConstants } from './GroupsConstants';
import { LimeError } from 'modules/application/misc/LimeError';
export class GroupsService {
    static $inject = ['MessagingHubService'];
    constructor(MessagingHubService) {
        'ngInject';
        this.MessagingHubService = MessagingHubService;
        this.createGroup = async (createGroupRequest) => {
            const uri = `${GroupsUriTemplates.GROUPS_BASE}`;
            const commandResponse = await this.MessagingHubService.processCommand({
                to: WhatsappConstants.WHATSAPP_GATEWAY_IDENTITY,
                method: 'set',
                uri: uri,
                type: GroupsConstants.GROUP_LIME_TYPE,
                resource: createGroupRequest,
            });
            const { resource } = await this.MessagingHubService
                .ensureCommandSuccess(commandResponse);
            return Boolean(resource);
        };
        this.deleteGroup = async (groupId) => {
            const uri = `${GroupsUriTemplates.GROUPS_BASE}/${groupId}`;
            const commandResponse = await this.MessagingHubService.processCommand({
                to: WhatsappConstants.WHATSAPP_GATEWAY_IDENTITY,
                method: 'delete',
                uri: uri,
            });
            const { resource } = await this.MessagingHubService
                .ensureCommandSuccess(commandResponse);
            return Boolean(resource);
        };
        this.updateGroup = async (groupId, updateGroupRequest) => {
            const uri = `${GroupsUriTemplates.GROUPS_BASE}/${groupId}`;
            const commandResponse = await this.MessagingHubService.processCommand({
                to: WhatsappConstants.WHATSAPP_GATEWAY_IDENTITY,
                method: 'set',
                uri: uri,
                type: GroupsConstants.UPDATE_GROUP_LIME_TYPE,
                resource: updateGroupRequest,
            });
            const { resource } = await this.MessagingHubService
                .ensureCommandSuccess(commandResponse);
            return Boolean(resource);
        };
        this.getGroupMembers = async (groupId) => {
            const uri = `${GroupsUriTemplates.GROUPS_BASE}/${groupId}/members`;
            const commandResponse = await this.MessagingHubService.processCommand({
                to: WhatsappConstants.WHATSAPP_GATEWAY_IDENTITY,
                method: 'get',
                uri: uri,
            });
            const success = commandResponse.status === 'success';
            const response = {
                groupId,
                members: success ? commandResponse.resource.items : [],
                error: success ? undefined : new LimeError(commandResponse.reason),
            };
            if (!success) {
                console.error(response.error);
            }
            return response;
        };
        this.manageGroupMembers = async (groupId, members, isActiveMember) => {
            const uri = `${GroupsUriTemplates.GROUPS_BASE}/${groupId}${GroupsUriTemplates.MEMBERS}`;
            const commandResponse = await this.MessagingHubService.processCommand({
                to: WhatsappConstants.WHATSAPP_GATEWAY_IDENTITY,
                method: 'set',
                uri: uri,
                type: GroupsConstants.GROUP_MEMBER_LIME_TYPE,
                resource: {
                    members,
                    isActiveMember,
                },
            });
            const { resource } = await this.MessagingHubService
                .ensureCommandSuccess(commandResponse);
            return Boolean(resource);
        };
        this.getGroupsStatuses = async (actions, groupId) => {
            const joinedActions = actions.join(';');
            const uri = `${GroupsUriTemplates.GROUPS_STATUSES}?statuses=${joinedActions}${groupId ? `&groupId=${groupId}` : ''}`;
            const commandResponse = await this.MessagingHubService.processCommand({
                to: WhatsappConstants.WHATSAPP_GATEWAY_IDENTITY,
                method: 'get',
                uri: uri,
            });
            const { resource } = await this.MessagingHubService
                .ensureCommandSuccess(commandResponse);
            return resource;
        };
    }
}
GroupsService.$inject = ['MessagingHubService'];
